
        import { InlineMath } from 'react-katex';
        import { BlockMath as MathBlock } from 'react-katex';
        
        export default { InlineMath, MathBlock };
        